export default {
    "Decentralization":"去中心化",
    "Coin-based":"幣本位",
    "Perpetual Options":"永續選擇權",
    "Future Derivatives Infrastructure":"未來的衍生性商品基礎設施",
    "Start Trading":"開始交易",
    "Trading":"交易",
    "Fund Pool":"資金池",
    "Recommendation Reward":"推薦獎勵",
    "Language":"語言",
    "Follow":"跟單交易",
    "Never Liquidate":"永不爆倉",
    "Eliminate Liquidation Risk":"消除爆倉風險",
    "Risk Management Easier":"風險管理較簡單",
    "High Leverage":"高槓桿",
    "Multiple Leverage":"倍高倍槓桿",
    "High Profit Potential":"收益潛力大",
    "Zero Slippage":"零滑點",
    "Execution Price Meets Expected Results":"執行價格符合預期結果",
    "Eliminate Impermanent Loss":"消除無常損失",
    "Commission Rate 15%":"佣金率50%",
    "Generous recommendation rewards, recognize your contribution":"豐厚的推薦獎勵，認可您的貢獻",
    "Generous recommendation rewards, recognize your contribution2":"豐厚的推薦獎勵<br/>認可您的貢獻",
    "Invite a friend":"邀請朋友",
    "Invite a friend to Fufuture via a referral link":"透過推薦連結邀請朋友加入Fufuture",
    "Friend completes first order":"朋友完成首單",
    "Friend accepts invitation and completes first order":"朋友接受邀請並完成首次訂單",
    "Get your commission":"領取您的佣金",
    "Get your commission immediately and claim it anytime":"立即獲得您的佣金，隨時可領取",
    "Create my link":"建立我的連結",
    "Deep liquidity supported by dual pools":"雙池支撐的深度流動性",
    "Public pool":"公營池",
    "Available liquidity":"可用流動資金",
    "Private pool":"私人池",
    "Add LP":"新增LP",
    "FAQ":"常見問題",
    "Future Derivatives Infrastructure2":"未來衍生性商品的基礎設施",
    "Dual liquidity pool":"雙流動性池",
    "Open liquidity pool":"開放式流動性池",
    "More stable liquidity":"流動性更穩定",
    "Reasonable pricing":"定價合理",
    "Price feed from third-party oracle":"三方預言機餵價",
    "Precise error control":"誤差控制精準",
    "BTC 24-hour trading volume summary":"BTC24小時交易量總結",
    "BTC holdings summary":"BTC持倉量總和",
    "ETH 24-hour trading volume summary":"ETH24小時交易量總結",
    "ETH holdings summary":"ETH持倉量總結",
    "q1":"我如何增強我的帳戶安全性？",
    "a1":"交易網站由錢包進入，保護好個人私鑰，請勿點擊釣魚連結和掃描未知二維碼。",
    "q2":"我如何存款？",
    "a2":"在Fufuture中選擇目標代幣所在的公鏈，選擇目標代幣進行存入操作。",
    "q3":"Fufuture上的交易手續費費是多少？",
    "a3":"永續選擇權只收取開倉時的1‰。"

}
